/* MISHKA Oct 21 (designer 5:15): delivery date always visible, optional, never blocks.
   PDP: Identixweb picker shown as a #F8F3EE card "Choose your delivery date"; once picked it collapses to "Delivery: Sat, Oct 24 · Change".
   Mobile <=749: sticky bar (date + Add to cart) while the real button is off-screen; hidden when the cart drawer or a Klaviyo pop-up is open.
   Cart page + drawer: top line "Delivery: … · Change" or "Choose your delivery date". Reads Identixweb's cart attributes product_<id>. */
(() => {
  if (window.MkDeliveryVisible) return; window.MkDeliveryVisible = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const SEP = ' |&| ';
  const css = `
  .mk-dd-card{background:#F8F3EE;border:1px solid #E8DDE3;border-radius:8px;padding:14px 16px;margin:0 0 16px;box-sizing:border-box;max-width:100%}
  .mk-dd-card .mk-dd-h{margin:0 0 8px;font-family:"Trio Grotesk",var(--font-body-family),sans-serif;font-weight:500;font-size:14px;letter-spacing:.02em;text-transform:none;color:#422B47}
  .mk-dd-card .mk-dd-h.mk-dd-loading{color:#8C7A8F;cursor:default;pointer-events:none}
  .mk-dd-card .mk-dd-h.mk-dd-ready{cursor:pointer}
  .mk-dd-card .mk-dd-retry{color:#422B47;text-decoration:underline}
  .mk-dd-card .mk-dd-opt{font-weight:400;color:#B77F8D;font-size:12.5px;margin-left:6px}
  .mk-dd-summary,.mk-dd-line{font-family:"Trio Grotesk",var(--font-body-family),sans-serif;font-weight:500;font-size:14px;line-height:1.4;letter-spacing:.02em;text-transform:none;color:#422B47;margin:0}
  .mk-dd-summary{display:none}
  .mk-dd-card.mk-dd-picked>*:not(.mk-dd-summary){display:none!important}
  .mk-dd-card.mk-dd-picked .mk-dd-summary{display:block}
  .mk-dd-change{appearance:none;background:none;border:0;padding:0;font:inherit;letter-spacing:inherit;color:#422B47;text-decoration:underline;text-underline-offset:3px;cursor:pointer}
  .mk-dd-sep{color:#C99C32;margin:0 6px}
  .mk-dd-line{display:block;background:#F8F3EE;border-radius:8px;padding:10px 14px;margin:0 0 12px}
  cart-drawer .mk-dd-line{margin:8px 2rem 12px}
  .mk-dd-line.mk-dd-line--cta{width:100%;box-sizing:border-box;margin:0 0 10px!important;text-align:center}
  .mk-dd-choose{display:block;width:100%;box-sizing:border-box;padding:12px 14px;border:1px solid #422B47;border-radius:5px;background:#fff;color:#422B47;text-decoration:none;font:inherit;letter-spacing:inherit}
  .mk-dd-line--cta:has(.mk-dd-choose){background:none;padding:0}
  .mk-dd-choose .mk-dd-opt{color:#B77F8D;font-weight:400;margin-left:4px}
  .mk-dd-bar{position:fixed;left:0;right:0;bottom:0;z-index:40;display:none;align-items:center;gap:12px;padding:10px 16px calc(10px + env(safe-area-inset-bottom));background:#FBF8F5;border-top:1px solid #E8DDE3;box-shadow:0 -2px 12px rgba(66,43,71,.08);box-sizing:border-box}
  .mk-dd-bar.mk-on{display:flex}
  .mk-dd-bar .mk-dd-bar__date{flex:1 1 auto;min-width:0;font-family:"Trio Grotesk",var(--font-body-family),sans-serif;font-weight:500;font-size:13px;line-height:1.3;color:#422B47;text-transform:none;letter-spacing:.02em;background:none;border:0;padding:0;text-align:left;text-decoration:underline;text-underline-offset:3px;cursor:pointer}
  .mk-dd-bar .mk-dd-bar__atc{flex:0 0 auto;min-height:44px;padding:0 18px;border:0;border-radius:4px;background:#422B47;color:#fff;font-family:"Trio Grotesk",var(--font-body-family),sans-serif;font-weight:500;font-size:13px;letter-spacing:.12em;text-transform:uppercase;cursor:pointer}
  @media (min-width:750px){.mk-dd-bar{display:none!important}}`;
  const st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function fmt(d) {
    const m = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/.exec(String(d || '').trim()); if (!m) return d || '';
    const y = m[3].length === 2 ? 2000 + +m[3] : +m[3];
    const dt = new Date(y, +m[2] - 1, +m[1]);
    return isNaN(dt) ? d : dt.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
  }
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- Product page ---------- */
  const card = document.querySelector('.identixweb-product-order-delivery');
  let pdpDate = '';
  if (card) {
    card.classList.add('mk-dd-card');
    const h = document.createElement('p'); h.className = 'mk-dd-h';
    h.innerHTML = 'No date chosen<span class="mk-dd-sep" aria-hidden="true"> · </span>Choose date<span class="mk-dd-opt">(optional)</span>'; /* Nov 1 wording */
    const sum = document.createElement('p'); sum.className = 'mk-dd-summary'; sum.setAttribute('aria-live', 'polite');
    const ensure = () => { if (!card.contains(h)) card.prepend(h); if (!card.contains(sum)) h.after(sum); };
    ensure(); new MutationObserver(ensure).observe(card, { childList: true });
    /* Oct 22 r8: until the app's calendar input exists, show a non-clickable "Loading dates…" heading. */
    const HTML_READY = h.innerHTML;
    /* Oct 23 fix: match the input anywhere in the card or app block, give up after 10 s and show a graceful fallback. */
    const calIn = () => card.querySelector('input.uiDeliveryCalendar') || document.querySelector('.identixweb-product-order-delivery input.uiDeliveryCalendar');
    let timedOut = false;
    const ready = () => {
      if (!calIn()) {
        if (timedOut) { if (!h.classList.contains('mk-dd-fallback')) { h.innerHTML = 'Optionally choose your delivery date<span class="mk-dd-opt">(calendar still loading \u00b7 <a href="#" class="mk-dd-retry">retry</a>)</span>'; h.classList.remove('mk-dd-loading'); h.classList.add('mk-dd-fallback'); h.removeAttribute('aria-busy'); } return false; }
        if (!h.classList.contains('mk-dd-loading')) { h.textContent = 'Loading dates\u2026'; h.classList.add('mk-dd-loading'); h.classList.remove('mk-dd-ready'); h.setAttribute('aria-busy', 'true'); }
        return false;
      }
      if (!h.classList.contains('mk-dd-ready')) { h.innerHTML = HTML_READY; h.classList.remove('mk-dd-loading', 'mk-dd-fallback'); h.classList.add('mk-dd-ready'); h.removeAttribute('aria-busy'); }
      return true;
    };
    if (!ready()) {
      const mo = new MutationObserver(() => { if (ready()) { mo.disconnect(); clearInterval(poll); } });
      mo.observe(document.body, { childList: true, subtree: true });
      const poll = setInterval(() => { if (ready()) { mo.disconnect(); clearInterval(poll); } }, 1000);
      setTimeout(() => { timedOut = true; ready(); }, 20000); /* Oct 29: 10 s -> 20 s (slow phones need 12-15 s); MO + 1 s poll keep watching indefinitely */
    }
    /* Oct 29: retry re-loads the Identixweb app script instead of the page; full reload only if a second retry is needed. */
    let mkRetries = 0;
    card.addEventListener('click', (e) => {
      if (!e.target.closest('.mk-dd-retry')) return;
      e.preventDefault();
      if (calIn()) { ready(); return; }
      if (++mkRetries > 1) { location.reload(); return; }
      timedOut = false; h.classList.remove('mk-dd-fallback'); ready();
      const src = (document.querySelector('script[src*="odd.identixweb.com"][src*="odd_preview"]') || {}).src || 'https://odd.identixweb.com/order-delivery-date/assets/js/odd_preview.min.js';
      const sc = document.createElement('script'); sc.async = true; sc.src = src + (src.indexOf('?') < 0 ? '?' : '&') + 'mk_retry=' + Date.now();
      document.head.appendChild(sc);
      const watch = setInterval(() => { if (ready()) clearInterval(watch); }, 1000);
      setTimeout(() => { if (!calIn()) { timedOut = true; ready(); } }, 20000);
    });
    h.addEventListener('click', () => { const i = calIn(); if (i) setTimeout(() => { try { i.focus(); i.click(); } catch (_) {} }, 0); });
    const read = () => {
      const v = card.querySelector('.deliveryDateValue, input[name="delivery_date"], input.uiDeliveryCalendar');
      return v && v.value ? v.value : '';
    };
    const paint = () => {
      const d = read();
      if (d === pdpDate) return; pdpDate = d;
      if (d) {
        sum.innerHTML = 'Delivery: ' + esc(fmt(d)) + '<span class="mk-dd-sep" aria-hidden="true">·</span><button type="button" class="mk-dd-change">Change</button>';
        if (!card.dataset.mkEditing) card.classList.add('mk-dd-picked');
      } else card.classList.remove('mk-dd-picked');
      bar && paintBar();
    };
    card.addEventListener('click', (e) => {
      if (e.target.closest('.mk-dd-change')) {
        card.classList.remove('mk-dd-picked'); card.dataset.mkEditing = '1';
        const i = card.querySelector('input.uiDeliveryCalendar'); if (i) { try { i.focus(); i.click(); } catch (_) {} }
      }
    });
    card.addEventListener('change', () => { delete card.dataset.mkEditing; setTimeout(() => { pdpDate = '#'; paint(); }, 50); }, true);
    setInterval(paint, 600);

    /* Sticky mobile bar */
    var bar = null;
    const form = card.closest('form') || document.querySelector('form[action*="/cart/add"]');
    const atc = form && form.querySelector('button[name="add"], button[type="submit"]');
    if (atc) {
      bar = document.createElement('div'); bar.className = 'mk-dd-bar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Delivery date and add to cart');
      bar.innerHTML = '<button type="button" class="mk-dd-bar__date"></button><button type="button" class="mk-dd-bar__atc">Add to cart</button>';
      document.body.appendChild(bar);
      var paintBar = () => { bar.querySelector('.mk-dd-bar__date').textContent = pdpDate ? 'Delivery: ' + fmt(pdpDate) + ' · Change' : 'No date chosen · Choose date'; };
      paintBar();
      bar.querySelector('.mk-dd-bar__date').addEventListener('click', () => {
        card.classList.remove('mk-dd-picked'); if (pdpDate) card.dataset.mkEditing = '1';
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      bar.querySelector('.mk-dd-bar__atc').addEventListener('click', () => atc.click());
      let atcVisible = true;
      new IntersectionObserver((en) => { atcVisible = en[0].isIntersecting; tick(); }).observe(atc);
      const blocked = () => !!(document.querySelector('cart-drawer.active, cart-drawer[open], cart-notification.active, .cart-notification.active') ||
        [...document.querySelectorAll('[role="dialog"][aria-modal="true"], .klaviyo-form[class*="klaviyo-form-"]')].some((d) => {
          if (d.closest('cart-drawer')) return false; const r = d.getBoundingClientRect(), cs = getComputedStyle(d);
          return cs.visibility !== 'hidden' && cs.display !== 'none' && r.width > 0 && r.height > 0 && r.left < innerWidth && r.right > 0 && r.top < innerHeight && r.bottom > 0; }));
      const footer = document.querySelector('footer');
      const tick = () => {
        const nearFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
        const on = window.innerWidth <= 749 && !atcVisible && !blocked() && !nearFooter && !atc.disabled;
        bar.classList.toggle('mk-on', on);
      };
      window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick);
      setInterval(tick, 500);
    }
  }

  /* ---------- Cart page + drawer ---------- */
  async function cartDate() {
    try {
      const c = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();
      if (!c.item_count) return { empty: true };
      const a = c.attributes || {};
      /* Oct 22 r8: one order-level date (most recently set), resolved the same way as mk-cart-date-sync.js. */
      const R = window.MkCartDate && MkCartDate.resolve ? MkCartDate.resolve(c) : null;
      /* Oct 28: only items that ship take a delivery date (gift cards don't); no shipping items = no date line. */
      const its = (c.items || []).filter((i) => i.requires_shipping !== false);
      if (!its.length) return { date: '', url: '', pickUrl: '' };
      const k = R ? (R.date ? R.src : '') : ((its.map((i) => 'product_' + i.variant_id).find((x) => a[x] && String(a[x]).split(SEP)[1])) || '');
      const it = k && its.find((i) => 'product_' + i.variant_id === k);
      const pu = (i) => (i.handle ? root + 'products/' + i.handle + '?variant=' + i.variant_id : i.url);
      const dated = (i) => !!k || [i.variant_id].some((id) => a['product_' + id] && String(a['product_' + id]).split(SEP)[1]);
      /* Oct 30 eve (Olia OK): "Choose"/"Change" target the cake line, not the newest line. Identixweb serves a calendar for
         every shipping product (jerky too), so rank by product: signature cake, other cakes, cake sets/bites; else first line. */
      const rank = (i) => { const h = String(i.handle || '') + ' ' + String(i.product_title || '');
        return /^signature-birthday-cake\b/.test(i.handle || '') ? 0 : !/cake/i.test(h) ? 9 : /set|bites/i.test(h) ? 2 : 1; };
      const cake = its.slice().reverse().sort((x, y) => rank(x) - rank(y))[0], best = rank(cake) < 9 ? cake : its[0];
      const und = k ? null : best;
      return { date: k ? (R && R.date ? R.date[0] : String(a[k]).split(SEP)[1]) : '', url: it ? pu(it) : '', pickUrl: und ? pu(und) : '', anyUrl: pu(best) };
    } catch (e) { return null; }
  }
  let last = null;
  async function paintLines() {
    const r = await cartDate(); if (!r) return; last = r;
    place();
  }
  function place() {
    /* Nov 1: Identixweb's cart-line "Edit Date" button reads "Change" (same word everywhere); its click behavior is untouched */
    document.querySelectorAll('button.editdate_product_order_delivery_date').forEach((b) => { if (b.textContent.trim() === 'Edit Date') b.textContent = 'Change'; });
    if (!last) return;
    const spots = [];
    /* Oct 22 r6: the date row sits directly above Checkout (drawer + /cart); the old top banner is removed. */
    document.querySelectorAll('cart-drawer-items > .mk-dd-line, #main-cart-items > .mk-dd-line, #main-cart > .mk-dd-line').forEach((n) => n.remove());
    const dBtn = document.querySelector('cart-drawer #CartDrawer-Checkout'); if (dBtn) spots.push([dBtn, 'drawer']);
    const pBtn = document.querySelector('#main-cart #checkout, #main-cart [name="checkout"], .cart__submit-controls [name="checkout"]'); if (pBtn && pBtn !== dBtn) spots.push([pBtn, 'page']);
    spots.forEach(([btn, ctx]) => {
      const el = btn.parentNode;
      let line = el.querySelector(':scope > .mk-dd-line');
      const idx = !!document.querySelector('.identixweb-order-delivery input, input.uiDeliveryCalendar, #main-cart [class*="identixweb"] input');
      /* Oct 22 r6: no picker on /cart (Identixweb plan is product-level). "Choose" links to the first undated item's product page; hidden if none. */
      if (last.empty || (!last.date && !last.pickUrl)) { if (line) line.remove(); return; }
      if (!line) { line = document.createElement('p'); line.className = 'mk-dd-line mk-dd-line--cta'; line.setAttribute('aria-live', 'polite'); }
      if (line.nextElementSibling !== btn) el.insertBefore(line, btn);
      /* Oct 22 r4: Change -> the dated item's product page (/products/<handle>?variant=<id>) on both /cart and the drawer. */
      /* Oct 29: Change falls back to the item's page when the date's source line can't be matched (it was missing on desktop /cart). */
      /* Oct 29 Date Change fix: Change opens the product page in change mode (calendar open, "Save new date", nothing added) */
      const chg0 = last.url || last.anyUrl || ''; const chg = chg0 ? chg0 + (chg0.indexOf('?') < 0 ? '?' : '&') + 'mk_change=1' : '';
      const html = last.date
        ? 'Delivery: ' + esc(fmt(last.date)) + (chg ? '<span class="mk-dd-sep" aria-hidden="true">·</span><a class="mk-dd-change" href="' + esc(chg) + '">Change</a>' : '')
        : 'No date chosen<span class="mk-dd-sep" aria-hidden="true">·</span><a class="mk-dd-change" href="' + esc(last.pickUrl) + '">Choose date</a>'; /* Nov 1: owner wording, date optional */
      if (line.dataset.h !== html) { line.dataset.h = html; line.innerHTML = html; }
    });
  }
  if (location.hash === '#mk-dd') setTimeout(() => { const box = document.querySelector('.identixweb-order-delivery'); if (box) box.scrollIntoView({ block: 'center' }); }, 1500);
  const nf = window.fetch;
  window.fetch = function (input) {
    const p = nf.apply(this, arguments);
    const u = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(() => setTimeout(paintLines, 1800), () => {});
    return p;
  };
  document.addEventListener('mk:cartdate', () => paintLines());

  /* Oct 23: Klaviyo add-to-cart form (WQzJYB). Opens only after the shopper closes the cart drawer, on /products/
     pages, never on /cart, never while the drawer/notification is open. No timed fallback. Klaviyo exit intent unchanged. */
  const klHook = () => {
    if (window.MK_WELCOME_FORM_OFF) return; /* Nov 3: welcome pop-up unpublished */
    if (!/\/products\//.test(location.pathname) || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    let pendingKl = null;
    const cartOpen = () => !!document.querySelector('cart-drawer.active, cart-drawer[open], cart-notification.active, .cart-notification.active');
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
      if (!ev || ev.source !== 'product-form' || pendingKl) return;
      let seenOpen = false;
      pendingKl = setInterval(() => {
        if (/\/cart(\/|$)/.test(location.pathname)) { clearInterval(pendingKl); return; }
        if (cartOpen()) { seenOpen = true; return; }
        if (!seenOpen) return; /* wait until the drawer has actually opened and then been closed */
        clearInterval(pendingKl); pendingKl = null;
        /* once per shopper, ever (owner rule): skip if already shown */
        try { if (localStorage.getItem('mk_kl_WQzJYB_shown')) { console.info('[mk] klaviyo WQzJYB skipped (already shown)'); return; } } catch (_) { return; }
        try { localStorage.setItem('mk_kl_WQzJYB_shown', String(Date.now())); } catch (_) {}
        window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', 'WQzJYB']);
        console.info('[mk] klaviyo openForm WQzJYB (drawer closed)');
      }, 250);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', klHook); else klHook();
  new MutationObserver(() => place()).observe(document.body, { childList: true, subtree: true });
  if (document.querySelector('cart-drawer, #main-cart')) paintLines();
})();

/* Oct 29 (Olia OK 9:15 AM PT): fallback date list. If the Identixweb input hasn't appeared 20 s after load, show our own
   open days (every Saturday except Oct 31; plus Nov 4-7, 11-14, 18-21). Saturday needs the order by Thursday 2 PM PT;
   other days need it by 2 PM PT two days before (FedEx 2Day). The pick is written after add-to-cart into the same cart
   attributes the app uses (product_<variant>, _mk_date, _mk_date_src). Hides itself if the app calendar shows up later.
   Never blocks add-to-cart. */
(() => {
  if (!/\/products\//.test(location.pathname)) return;
  const SEP = ' |&| ', root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const appIn = () => document.querySelector('input.uiDeliveryCalendar');
  const box = () => document.querySelector('.identixweb-product-order-delivery');
  const WD = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const EXTRA = ['2026-11-04', '2026-11-05', '2026-11-06', '2026-11-11', '2026-11-12', '2026-11-13', '2026-11-18', '2026-11-19', '2026-11-20'];
  const CLOSED = ['2026-10-31'];
  const ptNow = () => { const p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date()); const g = (t) => +p.find((x) => x.type === t).value; return { d: Date.UTC(g('year'), g('month') - 1, g('day')), h: g('hour') % 24 }; };
  const iso = (t) => new Date(t).toISOString().slice(0, 10);
  function days() {
    const n = ptNow(), out = [], DAY = 864e5;
    for (let i = 1; i <= 42 && out.length < 12; i++) {
      const t = n.d + i * DAY, s = iso(t), wd = new Date(t).getUTCDay();
      if (CLOSED.includes(s) || !(wd === 6 || EXTRA.includes(s))) continue;
      const lead = wd === 6 ? 2 : 2; /* Sat: Thursday 2 PM; others: 2 days before 2 PM */
      const cut = t - lead * DAY; if (n.d > cut || (n.d === cut && n.h >= 14)) continue;
      out.push(t);
    }
    return out;
  }
  let picked = null, ui = null;
  function show() {
    if (ui || appIn() || !box()) return;
    const ds = days(); if (!ds.length) return;
    ui = document.createElement('div'); ui.className = 'mk-dd-fb';
    ui.innerHTML = '<label class="mk-dd-fb__l" for="mk-dd-fb-s">Choose your delivery date <span class="mk-dd-opt">(optional)</span></label><select id="mk-dd-fb-s" class="mk-dd-fb__s"><option value="">No date yet</option>' +
      ds.map((t) => { const d = new Date(t); return '<option value="' + iso(t) + '">' + d.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }) + '</option>'; }).join('') + '</select>';
    ui.style.cssText = 'margin:.6rem 0;padding:.8rem 1rem;background:#F8F3EE;border-radius:8px';
    ui.querySelector('select').style.cssText = 'width:100%;min-height:44px;margin-top:.4rem;font:inherit';
    ui.querySelector('select').addEventListener('change', (e) => { picked = e.target.value || null; });
    /* Oct 30: once this list shows, the heading's '(calendar still loading · retry)' is hidden; retry lives here instead */
    const r = document.createElement('a'); r.href = '#'; r.className = 'mk-dd-retry mk-dd-fb__r'; r.textContent = 'Try the calendar again';
    r.style.cssText = 'display:inline-block;margin-top:.4rem;font-size:12.5px;color:#422B47;text-decoration:underline'; ui.appendChild(r);
    if (!document.getElementById('mk-dd-fb-css')) { const st = document.createElement('style'); st.id = 'mk-dd-fb-css'; st.textContent = '.mk-dd-has-fb .mk-dd-h .mk-dd-opt{display:none!important}'; document.head.appendChild(st); }
    box().classList.add('mk-dd-has-fb');
    box().appendChild(ui);
  }
  function hide() { if (ui && appIn()) { ui.remove(); ui = null; picked = null; const b = box(); if (b) b.classList.remove('mk-dd-has-fb'); } }
  setTimeout(show, 20000);
  setInterval(() => { hide(); }, 1000);
  const val = (s) => { const [y, m, d] = s.split('-'); return d + '/' + m + '/' + y + SEP + WD[new Date(s + 'T00:00:00Z').getUTCDay()]; };
  async function write(vid) {
    if (!picked || appIn() || !vid) return;
    const title = ((document.querySelector('.product__title h1, h1') || {}).textContent || '').trim();
    const k = 'product_' + vid, v = val(picked);
    const attributes = { [k]: title + SEP + v, _mk_date: v, _mk_date_src: k };
    await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes }) });
    document.dispatchEvent(new Event('mk:cartdate'));
  }
  const of = window.fetch;
  window.fetch = function (input, init) {
    const p = of.apply(this, arguments);
    const u = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/add/.test(u) && picked) {
      let vid = ''; try { const b = init && init.body; vid = b instanceof FormData ? b.get('id') : (JSON.parse(b).id || (JSON.parse(b).items || [{}])[0].id); } catch (_) {}
      vid = vid || ((document.querySelector('form[action*="/cart/add"] [name="id"]') || {}).value);
      p.then((r) => { if (r && r.ok) write(vid); }, () => {});
    }
    return p;
  };
})();
